/* eslint-disable @typescript-eslint/no-unused-vars */

import { partners } from '@components/home/our-partners'

export const menusWithSubChildren = ['/industries'] as const

export interface SubMenuItem {
  name: string
  slug: string
  id: string
}

export interface SubMenuItemWithChildren {
  name: string
  slug: string
  id: string
  items: SubMenuItem[]
}

export interface MenuItemWithCopy {
  name: string
  slug: '/about' | '/approach' | '/insights' | '/join' | '/velocity' // exactly typed to help with NextJS Link route checking
  id: string
  copy: string
}

export interface MenuItemWithSubChildren {
  name: string
  renderTopLevelLink: true
  slug: (typeof menusWithSubChildren)[number] // exactly typed to help with NextJS Link route checking
  id: string
  items: SubMenuItemWithChildren[]
}

interface MenuItemWithChildrenCommon {
  name: string
  id: string
  items: SubMenuItem[]
}
interface MenuItemWithChildrenLinked extends MenuItemWithChildrenCommon {
  renderTopLevelLink: true
  slug: '/services' // exactly typed to help with NextJS Link route checking
}
interface MenuItemWithChildrenUnlinked extends MenuItemWithChildrenCommon {
  renderTopLevelLink: false
  slug: '/partnerships' // exactly typed to help with NextJS Link route checking
}

export type MenuItemWithChildren =
  | MenuItemWithChildrenLinked
  | MenuItemWithChildrenUnlinked

// export interface MenuItemWithChildren {
//   name: string
//   slug: '/services' | '/partnerships' // exactly typed to help with NextJS Link route checking
//   id: string
//   renderTopLevelLink: boolean
//   items: SubMenuItem[]
// }

// type MenuItem =
//   | MenuItemWithCopy
//   | MenuItemWithChildren
//   | MenuItemWithSubChildren

const servicesItems: SubMenuItem[] = [
  {
    name: 'AI Strategy & Governance',
    slug: 'ai-strategy-and-governance',
    id: 'ai-strategy-and-governance',
  },
  {
    name: 'AI Literacy & Enablement',
    slug: 'ai-literacy-enablement',
    id: 'ai-literacy-enablement',
  },
  {
    name: 'AI Build & Assurance',
    slug: 'ai-build-assurance',
    id: 'ai-build-assurance',
  },
  {
    name: 'AI & Data Security',
    slug: 'ai-data-security',
    id: 'ai-data-security',
  },
]
const services: MenuItemWithChildren = {
  name: 'Services',
  slug: '/services',
  id: 'services',
  renderTopLevelLink: true,
  items: servicesItems,
}

const industriesItems: SubMenuItemWithChildren[] = [
  {
    name: 'Financial Services',
    slug: 'financial-services',
    id: 'financial-services',
    items: [
      { name: 'Banking', slug: 'banking', id: 'banking' },
      { name: 'Insurance', slug: 'insurance', id: 'insurance' },
      {
        name: 'Capital Markets',
        slug: 'capital-markets',
        id: 'capital-markets',
      },
    ],
  },
  {
    name: 'Energy & Utilities',
    slug: 'energy-utilities',
    id: 'energy-utilities',
    items: [
      { name: 'Trading', slug: 'trading', id: 'trading' },
      {
        name: 'Network Operations',
        slug: 'network-operations',
        id: 'network-operations',
      },
      { name: 'Retail', slug: 'retail', id: 'retail' },
    ],
  },
  {
    name: 'Retail',
    slug: 'retail',
    id: 'retail',
    items: [
      { name: 'Product Retail', slug: 'product-retail', id: 'product-retail' },
      {
        name: 'Retail Services',
        slug: 'retail-services',
        id: 'retail-services',
      },
      {
        name: 'Marketing & Merchandising',
        slug: 'marketing-merchandising',
        id: 'marketing-merchandising',
      },
    ],
  },
  {
    name: 'Resources',
    slug: 'resources',
    id: 'resources',
    items: [
      {
        name: 'Minerals & Metals',
        slug: 'minerals-and-metals',
        id: 'minerals-and-metals',
      },
      { name: 'Oil & Gas', slug: 'oil-and-gas', id: 'oil-and-gas' },
      {
        name: 'Resource Services',
        slug: 'resources-service-providers',
        id: 'resources-service-providers',
      },
    ],
  },
]
const industries: MenuItemWithSubChildren = {
  name: 'Industries',
  slug: '/industries',
  id: 'industries',
  renderTopLevelLink: true,
  items: industriesItems,
}

const alliancesItems: SubMenuItem[] = [
  { ...partners.anthropic, id: partners.anthropic.slug },
  // { ...partners.openai, id: partners.openai.slug },
  { ...partners.databricks, id: partners.databricks.slug },
  { ...partners.aws, id: partners.aws.slug },
  { ...partners.google, id: partners.google.slug },
  { ...partners.microsoft, id: partners.microsoft.slug },
]
const alliances: MenuItemWithChildren = {
  name: 'Alliances',
  id: 'alliances',
  slug: '/partnerships',
  renderTopLevelLink: false,
  items: alliancesItems,
}

const about: MenuItemWithCopy = {
  name: 'About',
  slug: '/about',
  id: 'about',
  copy: "We're one of APAC's fastest growing AI&NoBreak;-&NoBreak;Native Consultancies",
}
const velocity: MenuItemWithCopy = {
  name: 'Velocity',
  slug: '/velocity',
  id: 'velocity',
  copy: 'V2 AI adds enterprise velocity with AI-driven solutions',
}
const approach: MenuItemWithCopy = {
  name: 'Approach',
  slug: '/approach',
  id: 'approach',
  copy: 'Find out what makes V2 AI different',
}
const insights: MenuItemWithCopy = {
  name: 'Insights',
  slug: '/insights',
  id: 'insights',
  copy: 'Explore expert Data and AI trends',
}
const join: MenuItemWithCopy = {
  name: 'Join',
  slug: '/join',
  id: 'join',
  copy: 'Ready to make your mark?',
}

export const headerMenu: Array<
  MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren
> = [services, velocity, industries, alliances, insights, about, join]

type MenuItemsArray = Array<
  MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren
>

export const footerLeft: MenuItemsArray = [about, insights, join, services]
export const footerRight: MenuItemsArray = [industries]

export const menuItemIsWithChildren = (
  item: MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren,
): item is MenuItemWithChildren | MenuItemWithSubChildren => 'items' in item
